import { requestWithToken } from '../utilities/request';

const path = '/api/private/sessions';

//現場情報取得
// BLDE_V2-47901 現場IDをredisから取得していたがクエリパラメタから取得するように変更した
const getfield = async () => {
  const fieldId = new URLSearchParams(location.search).get('__currentFieldId') || sessionStorage.getItem('field_id');
  const response = {
    result: true,
    data: {
      entities: {
        field_id:  fieldId
      }
    }
  };
  return response;
};

//現場情報更新
// BLDE_V2-47901 redisの現場IDを更新していたが不要になった
const updatefield = async (fieldId) => {
  const response = {
    result: true,
  }
  return response;
};

//協力会社更新
const updatePartner = param => {
  return requestWithToken({
    method: 'PATCH',
    url: `${path}/update_partner`,
    data: param,
  });
};

//現場IDを元に、セッションが保持する現場ID、協力会社の会社ID、支店ID情報を更新する。
const updatePartnerByField = fieldId => {
  return requestWithToken({
    method: 'PATCH',
    url: `${path}/update_partner_by_field`,
    data: { field_id: fieldId },
  });
};

export const SessionsService = {
  getfield,
  updatefield,
  updatePartner,
  updatePartnerByField,
};
export default SessionsService;



// WEBPACK FOOTER //
// ./src/services/Sessions.js